export const SITE = {
  name: "Sai Grand Celebrations",
  shortName: "SGC",
  domain: "saigrandcelebrations.in",
  email: "saigrandcelebrations@gmail.com",
  phoneDisplay: "+91 XXXXX XXXXX", // placeholder — replace once the venue number is announced
  addressLine: "Full address will be announced at the grand opening",
  eventTypes: ["Grand Wedding", "Reception", "Sangeet", "Engagement", "Other Celebration"],
  categories: ["Mandap Stage", "Reception Hall", "Dining & Decor", "Sacred Moments", "Grand Entrance"],
  navLinks: [
    { label: "The Venue", id: "venue" },
    { label: "Gallery", id: "gallery" },
    { label: "Reserve Your Date", id: "book" },
  ],
};

export const AMENITIES = [
  { icon: "snowflake", title: "Centrally Air-Conditioned", text: "Cool, comfortable halls that stay pristine through every ritual and reception." },
  { icon: "sparkles", title: "Grand Stage & Lighting", text: "A commanding stage with ambient lighting designed for the vows, the varmala and beyond." },
  { icon: "bed", title: "Bridal Suite & Green Rooms", text: "Private, elegant rooms for the couple and family to prepare, rest and rehearse." },
  { icon: "utensils", title: "Catering Kitchen", text: "Fully equipped kitchen facilities ready for the caterers of your choice." },
  { icon: "car", title: "Valet Parking", text: "Guests arrive like royalty with smooth, organised vehicle care on site." },
  { icon: "zap", title: "Full Power Backup", text: "Celebrations that never pause — uninterrupted power through every function." },
  { icon: "speaker", title: "Premium Sound & AV", text: "Crystal-clear audio and visual support for ceremonies, sangeets and speeches." },
  { icon: "heart", title: "Dedicated Event Care", text: "A hands-on team to coordinate timings, vendors and flow so families stay present." },
];
